import type { Cloneable } from '@bindoc-projects/util-domain-lib';

export class BdAdministrativeDistrictId
  implements Cloneable<BdAdministrativeDistrictId>
{
  public static create(id: string | number): BdAdministrativeDistrictId | null {
    const idType = typeof id;
    let result = null;

    if (idType === 'string') {
      result = BdAdministrativeDistrictId.createFromString(id as string);
    } else if (idType === 'number') {
      result = BdAdministrativeDistrictId.createFromNumber(id as number);
    } else if (!id) {
      result = null;
    } else {
      throw new Error('Invalid administrative district id type.');
    }

    return result;
  }

  public static createFromNumber(id: number): BdAdministrativeDistrictId {
    const idStr = id.toString(10);

    return BdAdministrativeDistrictId.createFromString(idStr);
  }

  public static createFromString(id: string): BdAdministrativeDistrictId {
    if (id.length === 4) {
      id = `0${id}`;
    }

    return new BdAdministrativeDistrictId(id);
  }

  constructor(public value: string) {}

  public getNumericValue(): number {
    return parseInt(this.value, 10);
  }

  public getStateId(): number {
    return parseInt(this.value.substring(0, 2), 10);
  }

  public clone(): BdAdministrativeDistrictId {
    return new BdAdministrativeDistrictId(this.value);
  }
}
